import { StyleSheet } from 'react-native'

import { Box } from '../theme/restyle'
import { FALLBACK_ASSET_LOGO } from './assetLogos'
import { FunIcon } from './FunIcon'

export interface ChainAvatarProps {
  /** Full CDN logo URL, e.g. `chainIconUri('base')`. */
  uri: string
  size?: number
}

/**
 * A chain logo clipped to a circle with a hairline border. Centering a same-size
 * {@link FunIcon} keeps it from sitting 1px off, since the border-box hairline
 * shrinks the content box.
 */
export function ChainAvatar({ uri, size = 36 }: ChainAvatarProps) {
  return (
    <Box style={[styles.ring, { width: size, height: size }]}>
      <FunIcon uri={uri} size={size} fallbackUri={FALLBACK_ASSET_LOGO} />
    </Box>
  )
}

const styles = StyleSheet.create({
  // `border/icon` has no dark-mode counterpart in the token export, so it isn't
  // in tokens.ts and the hairline stays a literal.
  ring: {
    borderRadius: 999,
    borderWidth: 1,
    borderColor: 'rgba(0,0,0,0.1)',
    overflow: 'hidden',
    alignItems: 'center',
    justifyContent: 'center',
  },
})
